import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InfiniteScroller(_ref) {
  var children = _ref.children,
    loader = _ref.loader,
    dataLength = _ref.dataLength,
    hasMore = _ref.hasMore,
    next = _ref.next,
    scrollThreshold = _ref.scrollThreshold,
    style = _ref.style,
    endMessage = _ref.endMessage,
    scrollableTarget = _ref.scrollableTarget;
  return _jsx(InfiniteScroll, {
    loader: loader,
    dataLength: dataLength,
    hasMore: hasMore,
    next: next,
    scrollThreshold: scrollThreshold,
    style: style,
    endMessage: endMessage,
    scrollableTarget: scrollableTarget,
    children: children
  });
}